import React from 'react'

export default function PrintOnlyHeader() {
    return (
        <div className='print-only-header font-serifz' style={{ width: '100%', height: 'auto', padding: '0.5rem', minWidth: '100vw', display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
            <div style={{ width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src='/images/gok.png' alt='GOK MOHLogo' className='mb-3 mx-auto' style={{ width: '70px', height: 'auto' }} />
            </div>
            <h4 className='mb-0 text-blue-700 font-bold text-center'>MINISTRY OF HEALTH</h4>
            <h5 className='text-center'>DIVISION OF NATIONAL LABORATORY SERVICES</h5>
            <h6 className='text-center'>KENYA EXTERNAL QUALITY ASSESSMENT SCHEME(KNEQAS)</h6>
            <hr className='my-0' style={{
                borderColor: 'black',
                borderStyle: 'double'
            }} />
        </div>
    )
}